import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React, { useState, useEffect, useCallback } from 'react';
import Login from './Login';
import { Routes, Route, useNavigate, NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Collapse } from 'reactstrap';
import axios from 'axios';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from './Dashboard/Dashboard';
import {
    PersonVcardFill,
    QrCodeScan,
    CardList,
    PersonCircle,
    Search,
    CaretDownFill,
    CaretUpFill,
    PersonFillAdd,
    BusFrontFill,
    PersonLinesFill,
    Bell,
    FileEarmarkBreak
} from 'react-bootstrap-icons';
import GerenciamentoTurmas from './Dashboard/GerenciamentoTurmas/GerenciamentoTurmas';
import LeitorQr from './Dashboard/LeitorQr/LeitorQrWrapper';
import Integrantes from './Dashboard/GerenciamentoTurmas/Integrantes';
import AlunoSite from './Dashboard/AlunoSite/AlunoSite';
import RegistroEntradaSaida from './Dashboard/ListaRegistroAlunos/ListaRegistroAlunos';
import PesquisaRapida from './Dashboard/PesquisaRapida/PesquisaRapida';
import Motoristas from './Dashboard/Motoristas/Motoristas';
import ListaAguardo from './Dashboard/ListaAguardo/ListaAguardo';
import RegistroPessoalAluno from './Dashboard/RegistroPessoalAluno/RegistroPessoalAluno';
import NotaRegistroManual from './Dashboard/NotaRegistroManual/NotaRegistroManual';
import GerenciamentoMotoristas from './Dashboard/GerenciamentoMotoristas/GerenciamentoMotoristas';
import CadastroMotorista from './Dashboard/CadastroMotorista/CadastroMotorista';
import GeradorQrExterno from './Dashboard/GeradorQrExterno/GeradorQrExterno';
import SescLogo from './Assets/Sesc-SC-Logo.png';
import adapter from 'webrtc-adapter';
import { useMediaQuery } from 'react-responsive';
import Cookies from 'universal-cookie';
import './Quadrangle.otf';

const App = () => {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const [authToken, setAuthToken] = useState(cookies.get('authToken'));
    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');
    const [codigoTurma, setCodigoTurma] = useState(cookies.get('cdTurma'));
    const [alunosTurma, setAlunosTurma] = useState(null);
    const [alunoCodigo, setAlunoCodigo] = useState(null);
    const [alunoInfo, setAlunoInfo] = useState(null);
    const [modalRegistro, setModalRegistro] = useState(false);
    const [listaRegistroAlunos, setListaRegistroAlunos] = useState();
    const [cameraMode, setCameraMode] = useState(cookies.get('cameraMode'));
    const [statusLeitura, setStatusLeitura] = useState(true);
    const [modalEntradaManual, setModalEntradaManual] = useState(false);
    const [dadosRegistroManual, setDadosRegistroManual] = useState({ tipoRegistro: null });
    const [isMainMenuOpen, setIsMainMenuOpen] = useState(JSON.parse(localStorage.getItem('statusMainMenu')));
    const [alunosPorNome, setAlunosPorNome] = useState();
    const [userStatus, setUserStatus] = useState();
    const username = process.env.REACT_APP_ANJO_BACKEND_USER
    const password = process.env.REACT_APP_ANJO_BACKEND_PSW

    const tiers = {
        tier1: ['Secretária Escolar', 'coordenador', 'ANALISTA DE SISTEMAS'],
        tier2: ['Auxiliar de Classe', 'Auxiliar de Ensino', 'Inspetor (a) Escolar', 'Professor (a)'],
    };

    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 769px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })

    //DePara=> cdUnidadeDb2: cdUnidadeSophia
    const deParaUnidades = {
        "1":"1",
        "11":"1",
        "13":"2",
        "6":"3",
        "7":"4",
        "8":"5",
        "25":"6",
        "9":"7",
        "10":"8",
        "12":"9",
        "23":"10",
        "14":"11",
        "15":"12",
        "20":"13",
        "30":"14",
        "36":"15",
        "37":"16",
        "18":"17",
        "24":"18",
        "57":"19",
        "34":"20",
        "82":"21",
        "31":"22",
        "101": "23",
        "77":"3"
    };

    useEffect(() => {
        cookies.set('cameraMode', 'SAIDA');
    }, []);

    const toggleMainMenu = () => {
        setIsMainMenuOpen(!isMainMenuOpen)
        localStorage.setItem('statusMainMenu', JSON.stringify(!isMainMenuOpen));
    }

    const handleLogin = () => logar();

    const getTierByStatus = (token) => {
        let lowerCaseStatus = token.usuario.nomefuncao.toLowerCase();
        for (const tier in tiers) {
            if (tiers[tier].some((tierStatus) => tierStatus.toLowerCase() === lowerCaseStatus)) {
                return tier;
            }
        }
        return 'Unknown Tier';
    }

    const handleStatusLeitura = () => {
        setStatusLeitura(!statusLeitura);
    }

    const handleCameraMode = (transacao) => {
        cookies.set('cameraMode', transacao)
        setCameraMode(transacao);
    }

    const handleModalRegistro = () => {
        setModalRegistro(!modalRegistro);
        handleStatusLeitura();
    }
    
    const handleModalEntradaManual = () => {
        setModalEntradaManual(!modalEntradaManual);
    }

    const handleLogout = () => {
        setAuthToken(null);
        setUsuario('');
        setSenha('');
        cookies.remove('authToken');
        cookies.remove('cdTurma');
        localStorage.clear();
    }
 
    const logar = async () => {
        const params = new URLSearchParams();
        params.append('username', usuario);
        params.append('password', senha);

        const response = await axios.post(
            'login/usuario',
            params.toString(),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                auth: {
                    username: username,
                    password: password
                }
            }
        );
        startLogin(response.data);
    };

    const handleTurmaInfo = (cdTurma) => {
        setCodigoTurma(cdTurma);
        cookies.set('cdTurma', cdTurma, {
            expires: new Date(new Date().getTime() + 3600000)
        });
        redireconamentoAluno(cdTurma);
    }

    const redireconamentoAluno = async (cdTurma) => {
        const response = await axios.get("turma/integrantes/" + cdTurma ,
            {
                auth: {
                    username,
                    password
                }
            });
        localStorage.removeItem('alunosTurma');
        localStorage.setItem('alunosTurma', JSON.stringify(response.data));
        setAlunosTurma(response.data);
        navigate("/integrantesTurma");
    }

    const startLogin = (token) => {
        console.log(token)
        if (token) {
        cookies.set('authToken', token, {
            expires: new Date(new Date().getTime() + 3600000)
        });
        setAuthToken(token);
        setUserStatus(getTierByStatus(token));
        const logarUsuario = () => {
            navigate("/gerenciamentoTurmas");
        }
        
         logarUsuario();
        } else {
            alert('Usuario ou Senha Errados.')
            window.location.reload();
        }
    }

    const handleLeituraQr = (leitura) => {
        //let MAX_CHAR_HASH_QR_CODE = 64;
        let MAX_CHAR_HASH_QR_CODE = 11;
        handleStatusLeitura();
        if (leitura.length < MAX_CHAR_HASH_QR_CODE) {
            processAlunoInfo(leitura, true);
        } else if (leitura.length === MAX_CHAR_HASH_QR_CODE) {
            if (cookies.get('cameraMode') === 'ENTRADA') {
                comunicacaoEntrada(leitura);
            } else {
                comunicacaoSaida(leitura);
            }
        } else {
            window.location.reload();
        }
    }

    const comunicacaoEntrada = async (leitura) => {
            let leituraValid = String(leitura)
            const entradaResponse = await axios.get('responsavel/leituraCodigo/entrada/' + leituraValid + '/' + deParaUnidades[authToken.usuario.departamento.id.codfilial],
                {
                    auth: {
                        username,
                        password
                    }
                })
            setListaRegistroAlunos(entradaResponse.data);
        if (entradaResponse.data.length > 0) {
            setModalRegistro(true);
        } else {
            alert('O Codigo QR Escaneado não tem alunos disponíveis para Entrada');
            window.location.reload();
        }
    }

    const comunicacaoSaida = async (leitura) => {
        const saidaResponse = await axios.get('responsavel/leituraCodigo/saida/' + leitura + '/' + deParaUnidades[authToken.usuario.departamento.id.codfilial],
            {
                auth: {
                    username,
                    password
                }
            });
        setListaRegistroAlunos(saidaResponse.data);
        if (saidaResponse.data.length > 0) {
            setModalRegistro(true);
        } else {
            alert('O Codigo QR Escaneado não tem alunos disponíveis para Saída');
            window.location.reload();
        }
    }

    const processAlunoInfo = async (cdAluno, isLeituraQr) => {
        const response = await axios.get("aluno/" + cdAluno,
            {
                auth: {
                    username,
                    password
                }
            });

        if (response.data.cdAluno != null) {
            localStorage.removeItem('alunoSelecionado');
            localStorage.setItem('alunoSelecionado', JSON.stringify(response.data));
            setAlunoInfo(response.data);
            setAlunoCodigo(cdAluno);

            if (isLeituraQr) {
                handleStatusLeitura();
                setStatusLeitura(true);
            }

            navigate("/alunoSite");
        } else {
            if (isLeituraQr) {
                handleStatusLeitura();
                setStatusLeitura(true);
                alert("Codigo QR Errado.");
            } else {
                navigate("/alunoSite");
            }
        }
        
    }

    const processAlunoRegistro = async (cdAluno) => {
        const response = await axios.get("aluno/" + cdAluno,
            {
                auth: {
                    username,
                    password
                }
            });
        localStorage.removeItem('alunoSelecionado');
        localStorage.setItem('alunoSelecionado', JSON.stringify(response.data));
        setAlunoInfo(response.data);
        setAlunoCodigo(cdAluno);
        navigate("/registroPessoalAluno");
    }

    const topIdentificacaoResponsavel = () => {
        return (
            <>
                <div className="bubbleInfoRefistro">{listaRegistroAlunos && listaRegistroAlunos[0].resposaveis[0].nome} - [{listaRegistroAlunos && listaRegistroAlunos[0].resposaveis[0].vinculoFilial}]</div>
            </>
            )
    }

    const handleMarcarEntrada = (nomeResponsavel, vinculoFilial, cpfResponsavel) => {
        let matriculaFuncionario = authToken["usuario"]["matricula"];
        let isEntradaManual = true;
        let tipoRegistro = "ENTRADA"
        let dadosRegistro = {
            nomeResponsavel, vinculoFilial, cpfResponsavel, matriculaFuncionario, tipoRegistro, alunoCodigo,
            isEntradaManual
        }
        setDadosRegistroManual(dadosRegistro);
        fluxoMarcarSaidaManual();
    }

    const handleMarcarEntradaComNota = async (notaManual) => {
        let nomeResponsavel = dadosRegistroManual.nomeResponsavel;
        let vinculoFilial = dadosRegistroManual.vinculoFilial;
        let alunoCodigo = dadosRegistroManual.alunoCodigo;
        let matriculaFuncionario = dadosRegistroManual.matriculaFuncionario;
        let cpfResponsavel = dadosRegistroManual.cpfResponsavel;
        let isEntradaManual = dadosRegistroManual.isEntradaManual;

        const entradaResponse =
            await axios.post('aluno/marcar/entrada', {
                nomeResponsavel,
                vinculoFilial,
                alunoCodigo,
                matriculaFuncionario,
                cpfResponsavel,
                isEntradaManual,
                notaManual
            },
                {
                    auth: {
                        username,
                        password
                    }
                });

            if (entradaResponse.data) {
               alert("Entrada Marcada Com Sucesso");
            } else {
               alert("O Aluno já tem registro de entrada no día.");
            }

        handleModalEntradaManual();
    }

    const handleMarcarSaida = (nomeResponsavel, vinculoFilial, cpfResponsavel) => {
        let matriculaFuncionario = authToken["usuario"]["matricula"];
        let isEntradaManual = true;
        let tipoRegistro = "SAIDA"
        let dadosRegistro = {
            nomeResponsavel, vinculoFilial, cpfResponsavel, matriculaFuncionario, tipoRegistro, alunoCodigo,
            isEntradaManual
        }
        setDadosRegistroManual(dadosRegistro);
        fluxoMarcarSaidaManual();
    }

    const fluxoMarcarSaidaManual = () => {
        handleModalEntradaManual();
    }

    const handleMarcarSaidaComNota = async (notaManual) => {
        let nomeResponsavel = dadosRegistroManual.nomeResponsavel;
        let vinculoFilial = dadosRegistroManual.vinculoFilial;
        let alunoCodigo = dadosRegistroManual.alunoCodigo;
        let matriculaFuncionario = dadosRegistroManual.matriculaFuncionario;
        let cpfResponsavel = dadosRegistroManual.cpfResponsavel;
        let isEntradaManual = dadosRegistroManual.isEntradaManual;

        const retiroResponse =
            await axios.post('aluno/marcar/saida', {
                nomeResponsavel,
                vinculoFilial,
                alunoCodigo,
                matriculaFuncionario,
                cpfResponsavel,
                isEntradaManual,
                notaManual
            },
                {
                    auth: {
                        username,
                        password
                    }
                });

        if (retiroResponse.data) {
            alert("Saída Marcada Com Sucesso");
        } else {
            alert("O Aluno já tem registro de saída no día.");
        }

        handleModalEntradaManual();
    }

    const handlePesquisaAlunoPorNome = async (nome) => {
        let cdUnidadeSophia = deParaUnidades[authToken.usuario.departamento.id.codfilial]
        const alunosPorNomeCall =
            await axios.post('aluno/pesquisa/porNome/' + nome, {
                cdUnidadeSophia
            },
                {
                    auth: {
                        username,
                        password
                    }
                });
        localStorage.removeItem('alunosPorNome');
        localStorage.setItem('alunosPorNome', JSON.stringify(alunosPorNomeCall.data));
        setAlunosPorNome(alunosPorNomeCall.data);
    }

    const handleMarcarRegistroMultiple = async (listaALunosMarcar) => {
        let matriculaFuncionario = authToken["usuario"]["matricula"];
        handleStatusLeitura();
        if (cookies.get('cameraMode') === 'ENTRADA') {
            const registroEntrada =
                await axios.post('aluno/marcar/entradaMultiple/' + matriculaFuncionario,
                    listaALunosMarcar,
                    {
                        auth: {
                            username,
                            password
                        }
                    });
            setModalRegistro(false);
        } else {
            const registroSaida =
                await axios.post('aluno/marcar/saidaMultiple/' + matriculaFuncionario,
                    listaALunosMarcar,
                    {
                        auth: {
                            username,
                            password
                        }
                    });
            handleStatusLeitura();
            setModalRegistro(false);
        }
    }

    const alertarAlunos = async () => {
        let matriculaFuncionario = authToken["usuario"]["matricula"];
        let alunoList = [];
        let cpfResponsavel = dadosRegistroManual.cpfResponsavel;
        alunoList.push(alunoInfo);
        const alertaAlunos =
            await axios.post('aluno/marcar/alertaMultiple/' + cpfResponsavel + '/' + matriculaFuncionario,
                alunoList,
                {
                    auth: {
                        username,
                        password
                    }
                });
    }

    const alertarAlunosEmLeitura = async (alunos) => {
        let matriculaFuncionario = authToken["usuario"]["matricula"];
        let cpfResponsavelLista = alunos[0].resposaveis[0].cpfResponsavel;
        console.log(cpfResponsavelLista);
        const alertaAlunos =
            await axios.post('aluno/marcar/alertaMultiple/' + cpfResponsavelLista + '/' + matriculaFuncionario,
                alunos,
                {
                    auth: {
                        username,
                        password
                    }
                });
        alert('Alerta enviada com sucesso.');
        setModalRegistro(false);
        window.location.reload();
    }

    const Navigation = (args) => {
        return (
            <>{isDesktopOrLaptop && 
                <>
                <div className="cardUsuario">
                <div className="iconeCardUsuario">
                    <PersonCircle size={60} />
                </div>
                <div className="cardUsuarioInfo">
                    <strong>{authToken.usuario.nome}</strong>
                    <br />
                    {authToken.usuario.nomefuncao}
                </div>
            </div>
                
                <nav className="NavbarConfig">
                    <div className="botaoIcone">
                        <img src={SescLogo} className="DashLogo" />
                        <button className="LogoutButtonSmallScreen" type="button" onClick={handleLogout}>
                            Sair
                        </button>
                    </div>
                    <div id="TituloNavbar" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                        <strong> Anjo Sesc </strong>
                    </div>
                    <NavLink className="LinkRedir" to="/gerenciamentoTurmas" >
                        <PersonVcardFill size={25} className="IconeNav" />
                        Gestão de Turmas
                    </NavLink>
                    <div className="Divider" />

                    <NavLink className="LinkRedir" to="/leitorQr" >
                        <QrCodeScan size={25} className="IconeNav" />
                        Leitor de Acesso
                    </NavLink>

                    <div className="Divider" />

                    <NavLink className="LinkRedir" to="/listaAguardo" >
                        <CardList size={25} className="IconeNav" />
                        Solicitação de saída
                    </NavLink>
                    <div className="Divider" />
                    <NavLink className="LinkRedir" to="/pesquisaRapida" >
                        <Search size={25} className="IconeNav" />
                        Pesquisa Rápida
                    </NavLink>
                    
                    <div className="Divider" />
                    {/*<NavLink className="LinkRedir" to="/gerenciamentoMotoristas" >*/}
                    {/*    <PersonLinesFill size={25} className="IconeNav" />*/}
                    {/*    Gerenciamento Motoristas*/}
                    {/*    </NavLink>*/}

                    {/* <div className="Divider" />*/}
                    {/*    <NavLink className="LinkRedir" to="/cadastroMotorista" >*/}
                    {/*        <PersonFillAdd size={25} className="IconeNav" />*/}
                    {/*        Cadastro Motorista*/}
                    {/*    </NavLink>*/}

                    {/*<div className="Divider" />*/}

                    {/*<NavLink className="LinkRedir" to="/procesarMotoristas" >*/}
                    {/*    <BusFrontFill size={25} className="IconeNav" />*/}
                    {/*    Motoristas*/}
                    {/*</NavLink>*/}

                    {/*<div className="Divider" />*/}

                    <NavLink className="LinkRedir" to="/gerarCpfQrCode" >
                       <FileEarmarkBreak size={25} className="IconeNav" />
                        Gerador QR
                    </NavLink>

                    <button className="LogoutButtonBigScreen" type="button" onClick={handleLogout}>
                        Sair
                    </button>
                    </nav>
                </>}
                {isTabletOrMobile &&
                    <>
                        <nav className="NavbarConfig">
                            <div className="botaoIcone">
                            <img src={SescLogo} className="DashLogo" />
                                <button className="LogoutButtonSmallScreen" type="button" onClick={handleLogout}>
                                    Sair
                                </button>
                            </div>
                            <div id="TituloNavbar" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                                <strong> Anjo Sesc </strong>
                            </div>
                            <Collapse isOpen={!isMainMenuOpen}>
                                <NavLink className="LinkRedir" to="/gerenciamentoTurmas" >
                                    <PersonVcardFill size={25} className="IconeNav" />
                                    Gestão de Turmas
                                </NavLink>
                                <div className="Divider" />

                                <NavLink className="LinkRedir" to="/leitorQr" >
                                    <QrCodeScan size={25} className="IconeNav" />
                                    Leitor de Acesso
                                </NavLink>

                                <div className="Divider" />

                            <NavLink className="LinkRedir" to="/listaAguardo" >
                                    <CardList size={25} className="IconeNav" />
                                    Solicitação de saída
                                </NavLink>
                                <div className="Divider" />
                                <NavLink className="LinkRedir" to="/pesquisaRapida" >
                                    <Search size={25} className="IconeNav" />
                                    Pesquisa Rápida
                            </NavLink>
                          
                                <div className="Divider" />
                            {/*    <NavLink className="LinkRedir" to="/gerenciamentoMotoristas" >*/}
                            {/*        <PersonLinesFill size={25} className="IconeNav" />*/}
                            {/*        Gerenciamento Motoristas*/}
                            {/*    </NavLink>*/}
                           
                            {/*    <div className="Divider" />*/}

                            {/*    <NavLink className="LinkRedir" to="/cadastroMotorista" >*/}
                            {/*        <PersonFillAdd size={25} className="IconeNav" />*/}
                            {/*        Cadastro Motorista*/}
                            {/*    </NavLink>*/}

                            {/*<div className="Divider" />*/}

                            {/*<NavLink className="LinkRedir" to="/procesarMotoristas" >*/}
                            {/*    <BusFrontFill size={25} className="IconeNav" />*/}
                            {/*    Motoristas*/}
                            {/*</NavLink>*/}

                            {/*<div className="Divider" />*/}

                            <NavLink className="LinkRedir" to="/gerarCpfQrCode" >
                                <FileEarmarkBreak size={25} className="IconeNav" />
                                Gerador QR
                            </NavLink>

                            </Collapse>
                            <button className="LogoutButtonBigScreen" type="button" onClick={handleLogout}>
                                Sair
                            </button>
                        </nav>

                        <Button className="collapseButton" onClick={() => toggleMainMenu()}>
                            {!isMainMenuOpen ? <CaretUpFill size="10" /> : <CaretDownFill size="10" />}
                        </Button>
                    </>}
            </>
        );
    }

    return (
        <>
            {isDesktopOrLaptop &&
                <div className="Home">
                    {authToken ? (
                        <Navigation />
                    ) : undefined}
                    <Routes>
                        <Route element={<ProtectedRoute authToken={authToken} />}>
                            <Route path="dashboard" element={<Dashboard token={authToken} />} />
                            <Route path="gerenciamentoTurmas" element={<GerenciamentoTurmas token={authToken} putTurma={handleTurmaInfo} deParaUnidades={deParaUnidades}/>} />
                            <Route path="leitorQr" element={<LeitorQr token={authToken} putLeituraQr={handleLeituraQr} putModalLeitura={handleModalRegistro} putCameramode={handleCameraMode}
                                cameraMode={cameraMode} statusLeitura={statusLeitura} />} />
                            <Route path="integrantesTurma" element={<Integrantes token={authToken} putIntegrante={processAlunoInfo} putIntegranteRegistro={processAlunoRegistro} integrantes={alunosTurma} />} />
                            <Route path="alunoSite" element={<AlunoSite token={authToken} marcarSaida={handleMarcarSaida} marcarEntrada={handleMarcarEntrada} />} />
                            <Route path="listaAguardo" element={<ListaAguardo token={authToken} deParaUnidades={deParaUnidades}/>} />
                            <Route path="gerenciamentoMotoristas" element={<GerenciamentoMotoristas token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="cadastroMotorista" element={<CadastroMotorista token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="procesarMotoristas" element={<Motoristas token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="registroPessoalAluno" element={<RegistroPessoalAluno cdAluno={alunoCodigo} />} />
                            <Route path="pesquisaRapida" element={<PesquisaRapida buscarAlunoPorNome={handlePesquisaAlunoPorNome}
                                putIntegranteRegistro={processAlunoRegistro} putIntegrante={processAlunoInfo}
                                alunos={alunosPorNome}/>} />
                        </Route>
                        <Route index element={<Login logar={handleLogin} putUser={setUsuario} putSenha={setSenha} token={authToken} />} />
                        <Route path="login" element={<Login logar={handleLogin} putUser={setUsuario} putSenha={setSenha} token={authToken} />} />
                        <Route path="gerarCpfQrCode" element={<GeradorQrExterno logar={handleLogin} putUser={setUsuario} putSenha={setSenha} token={authToken} />} />
                        <Route path="*" element={<Login logar={handleLogin} putUser={setUsuario} putSenha={setSenha} />} token={authToken} />
                    </Routes>
                    <Modal isOpen={modalRegistro} toggle={handleModalRegistro}>
                        <ModalHeader className="TabelaGer" toggle={handleModalRegistro}>
                            <h4>{cameraMode === 'ENTRADA' ? "Registro de Entrada" : "Registro de Saida"}</h4>
                            {topIdentificacaoResponsavel()}
                        </ModalHeader>
                        <ModalBody className="modalConfig">
                            <RegistroEntradaSaida
                                listaRegistroAlunos={listaRegistroAlunos}
                                putAlunoLista={handleMarcarRegistroMultiple}
                                putModalLeitura={handleModalRegistro}
                                cameraMode={cameraMode}
                                alertarEmLeitura={alertarAlunosEmLeitura}/>
                        </ModalBody>
                    </Modal>
                     <Modal isOpen={modalEntradaManual} toggle={handleModalEntradaManual}>
                        <ModalHeader className="TabelaGer" toggle={handleModalEntradaManual}>
                            <div className="TopRegistro">
                                <h4>Nota de Registro Manual</h4>
                                {dadosRegistroManual.tipoRegistro === "SAIDA" ?
                                    (<Button className="AlunoAlertButton" onClick={() => alertarAlunos()}>
                                    <Bell size={20} />
                                    Alertar
                                </Button>):""}
                            </div>
                        </ModalHeader>
                        <ModalBody className="modalConfig">
                            <NotaRegistroManual dadosRegistro={dadosRegistroManual}
                                putMarcarEntrada={handleMarcarEntradaComNota}
                                putMarcarSaida={handleMarcarSaidaComNota} />
                        </ModalBody>
                    </Modal>
                </div>      
            }
            {isTabletOrMobile &&
                <>
                <div className="Home">
                    {authToken ? (
                        <Navigation />
                    ) : undefined}
                    <Routes>
                        <Route element={<ProtectedRoute authToken={authToken} />}>
                            <Route path="dashboard" element={<Dashboard token={authToken} />} />
                            <Route path="gerenciamentoTurmas" element={<GerenciamentoTurmas token={authToken} putTurma={handleTurmaInfo} deParaUnidades={deParaUnidades}/>} />
                            <Route path="leitorQr" element={<LeitorQr token={authToken} putLeituraQr={handleLeituraQr} putModalLeitura={handleModalRegistro} putCameramode={handleCameraMode}
                                cameraMode={cameraMode} statusLeitura={statusLeitura} />} />
                            <Route path="integrantesTurma" element={<Integrantes token={authToken} putIntegrante={processAlunoInfo} putIntegranteRegistro={processAlunoRegistro} integrantes={alunosTurma} />} />
                            <Route path="alunoSite" element={<AlunoSite token={authToken} marcarSaida={handleMarcarSaida} marcarEntrada={handleMarcarEntrada} />} />
                            <Route path="listaAguardo" element={<ListaAguardo token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="gerenciamentoMotoristas" element={<GerenciamentoMotoristas token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="cadastroMotorista" element={<CadastroMotorista token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="procesarMotoristas" element={<Motoristas token={authToken} deParaUnidades={deParaUnidades} />} />
                            <Route path="registroPessoalAluno" element={<RegistroPessoalAluno cdAluno={alunoCodigo} />} />
                            <Route path="pesquisaRapida" element={<PesquisaRapida buscarAlunoPorNome={handlePesquisaAlunoPorNome}
                                putIntegranteRegistro={processAlunoRegistro} putIntegrante={processAlunoInfo}
                                alunos={alunosPorNome} />} />
                        </Route>
                        <Route index element={<Login logar={handleLogin} putUser={setUsuario} putSenha={setSenha} token={authToken} />} />
                        <Route path="login" element={<Login logar={handleLogin} putUser={setUsuario} putSenha={setSenha} token={authToken} />} />
                        <Route path="gerarCpfQrCode" element={<GeradorQrExterno logar={handleLogin} putUser={setUsuario} putSenha={setSenha} token={authToken} />} />
                        <Route path="*" element={<Login logar={handleLogin} putUser={setUsuario} putSenha={setSenha} />} token={authToken} />
                    </Routes>
                    <Modal isOpen={modalRegistro} toggle={handleModalRegistro}>
                        <ModalHeader className="TabelaGer" toggle={handleModalRegistro}>
                            <h4>{cameraMode === 'ENTRADA' ? "Registro de Entrada" : "Registro de Saida"}</h4>
                            {topIdentificacaoResponsavel()}
                        </ModalHeader>
                        <ModalBody className="modalConfig">
                            <RegistroEntradaSaida
                                listaRegistroAlunos={listaRegistroAlunos}
                                putAlunoLista={handleMarcarRegistroMultiple}
                                putModalLeitura={handleModalRegistro}
                                cameraMode={cameraMode}
                                alertarEmLeitura={alertarAlunosEmLeitura}/>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={modalEntradaManual} toggle={handleModalEntradaManual}>
                        <ModalHeader className="TabelaGer" toggle={handleModalEntradaManual}>
                            <div className="TopRegistro">
                                <h4>Nota de Registro Manual</h4>
                                {dadosRegistroManual.tipoRegistro === "SAIDA" ?
                                    (<Button className="AlunoAlertButton" onClick={() => alertarAlunos()}>
                                        <Bell size={20} />
                                        Alertar
                                    </Button>) : ""}
                            </div>
                        </ModalHeader>
                        <ModalBody className="modalConfig">
                            <NotaRegistroManual dadosRegistro={dadosRegistroManual}
                                putMarcarEntrada={handleMarcarEntradaComNota}
                                putMarcarSaida={handleMarcarSaidaComNota} />
                        </ModalBody>
                    </Modal>
                </div> 
                </>
            }
        </>
    );
}

export default App;
